/** CSS `top` for the subtitle drag handle. Top/middle positions measure
 *  marginVertical from the top; bottom-center measures it from the bottom,
 *  matching the subtitle renderer. */
export function resolveSubtitleDragHandleTop(
  position: string,
  marginVertical: number,
): string {
  if (position === 'bottom-center') {
    return `${100 - marginVertical}%`;
  }
  return `${marginVertical}%`;
}
